<template>
  <div
    class="d-flex"
    :class="disabled ? 'p-checkbox--disabled' : 'p-checkbox'"
    @click="emitNewValue"
  >
    <div
      :class="disabled ? 'p-checkbox__box--disabled' : 'p-checkbox__box'"
      tabindex="0"
      @keyup.space="emitNewValue"
    >
      <div :class="innetBoxCss"></div>
    </div>
    <div>
      <p v-if="helpTitle" class="p-checkbox__label ml-4 mb-2">
        <strong>{{ helpTitle }}</strong>
      </p>
      <p v-if="label.length > 0" class="p-checkbox__label ml-4">{{ label }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    value: boolean;
    label?: string;
    helpTitle?: string;
    disabled?: boolean;
  }>(),
  {
    label: "",
    disabled: false,
  }
);

const emit = defineEmits<{
  (e: "value-changed", newValue: boolean): void;
}>();

const innetBoxCss = computed(
  () =>
    `p-checkbox__box__inner ${
      props.value ? "p-checkbox__box__inner--active" : ""
    }`
);

function emitNewValue(): void {
  if (!props.disabled) {
    emit("value-changed", !props.value);
  }
}
</script>

<style scoped lang="scss">
.p-checkbox {
  cursor: pointer;
  &--disabled {
    cursor: default;
  }
}

.p-checkbox__box {
  height: fit-content;
  border: 2px solid var(--darker-grey);
  border-radius: 6px;
  background-color: white;
  &--disabled {
    border: 2px solid var(--light-grey-1);
    border-radius: 6px;
    height: fit-content;
    .p-checkbox__box__inner {
      height: 10px;
      width: 10px;
      margin: 3px;
      border-radius: 3px;
      background-color: transparent;
    }
  }

  .p-checkbox__box__inner {
    height: 10px;
    width: 10px;
    margin: 3px;
    border-radius: 3px;
    background-color: transparent;
    &--active {
      background-color: var(--darker-grey);
    }
  }
}

.p-checkbox__label {
  line-height: 16px;
}
</style>
